import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Latisse Forms
   */
  {
    // 1
    label:
      'Why do you think you would benefit from LATISSE®? Please explain in your own words.',
    field: 'whyBenefit',
    type: 'info',
    answer: {
      type: 'text',
      name: 'benefit',
      placeholder: 'Please describe'
    }
  },
  {
    // 2
    label: 'Have you ever had any of the following symptoms?',
    field: 'symptoms',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'itchyEyelids',
          value: 'Itchy, red or swollen eyelids?',
          answer: {
            type: 'text',
            name: 'itchyEyelidsDesc',
            placeholder: 'explain'
          }
        },
        {
          key: 'infectionEyes',
          value:
            'Any type of infection, allergy, irritation, or unusual discharge from your eyes?',
          answer: {
            type: 'text',
            name: 'infectionEyesDesc'
          }
        },
        {
          key: 'visionIssues',
          value: 'Vision issues with your eyesight, such as blurry vision?',
          answer: {
            type: 'text',
            name: 'visionIssuesDesc'
          }
        },
        {
          key: 'elevatedPressure',
          value: 'Ever experienced elevated intraocular pressure?',
          answer: {
            type: 'text',
            name: 'elevatedPressureDesc'
          }
        },
        {
          key: 'haveGlaucoma',
          value: 'Do you have Glaucoma?',
          answer: {
            type: 'text',
            name: 'haveGlaucomaDesc'
          }
        },
        {
          key: 'hadMacularEdema',
          value: 'Have you had Macular Edema?',
          answer: {
            type: 'text',
            name: 'hadMacularEdemaDesc'
          }
        },
        {
          key: 'issuesWithLenses',
          value: 'Experienced any issues with the lenses of your eye?',
          answer: {
            type: 'text',
            name: 'issuesWithLensesDesc'
          }
        },
        {
          key: 'hadUveitis',
          value: 'Had Uveitis or any eye inflammation at all?',
          answer: {
            type: 'text',
            name: 'hadUveitisDesc'
          }
        },
        {
          key: 'issuesWithTearDucts',
          value: 'Any issues with your tear ducts?',
          answer: {
            type: 'text',
            name: 'issuesWithTearDuctsDesc'
          }
        },
        {
          key: 'lossOfEyelashes',
          value: 'Noticeable or rapid loss of your eyelashes or eyebrows?',
          answer: {
            type: 'text',
            name: 'lossOfEyelashesDesc'
          }
        },
        {
          key: 'isNone',
          value: 'I have none of these problems?',
          uncheckOthers: true
        }
      ]
    }
  },

  {
    // 3
    label:
      'Have you ever had issues with easy breakage of your hair? (lashes, eyebrows, scalp)',
    field: 'thickenedOrWeakPoints',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yesDesc',
            placeholder: 'Explain...'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },

  {
    // 4
    label:
      'Have you had any other issues or history involving your eyes/eyebrows or areas nearby?',
    field: 'eyeIssuesHistory',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yesDesc',
            placeholder: 'Explain...'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },

  {
    // 5
    label:
      'Any reactions/sensitivity to any eye drops or contact lens solutions?',
    field: 'eyedropSensitivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            placeholder: 'Explain...',
            type: 'text',
            name: 'yesDesc'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },

  {
    // 6
    label:
      'Are you aware of any sensitivity you may have to any of the ingredients of LATISSE®? Bimatoprost, Benzalkonium chloride, sodium chloride, sodium phosphate dibasic, citric acid, purified water, hydrochloric acid, sodium hydroxide',
    field: 'ingredientsSensitivity',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            placeholder: 'Explain...',
            type: 'text',
            name: 'yesDesc'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },

  {
    // 7
    label: 'Are you pregnant or plan on becoming pregnant?',
    field: 'isPregnant',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            placeholder: 'Explain...',
            type: 'text',
            name: 'yesDesc'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },

  {
    // 8
    label:
      'Are you currently Breastfeeding or planning to breastfeed in the near future?',
    field: 'currentlyBreastfeeding',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            placeholder: 'Explain...',
            type: 'text',
            name: 'yesDesc'
          }
        },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    // 9
    label:
      'If I wear contact lenses, I know that it is advised to apply LATISSE® at night after you have taken out your contact lenses.',
    field: 'consent1',
    type: 'info',
    answer: {
      type: 'consent-check',
      name: 'latisse',
      required: true
    }
  },
  {
    // 10
    label:
      'If you experience new conditions pertaining to their eyes or skin around your eyes, a sudden decrease in visual acuity, any ocular surgery - or develop any reaction of any type in or around the eyes - you should stop use and seek medical advice from our medical team or medical professional of your choice',
    field: 'consent2',
    type: 'info',
    answer: {
      type: 'consent-check',
      name: 'patient',
      required: true
    }
  },
  {
    // 11
    label:
      'LATISSE®️ solution use may cause darkening of the eyelid skin which may be reversible. LATISSE®️ use may cause increased brown iris pigmentation of the colored part of the eye which is likely to be permanent. While very infrequent, increased iris pigmentation has occurred when LATISSE®️ was administered.',
    field: 'consent3',
    type: 'info',
    answer: {
      type: 'consent-check',
      name: 'darkening',
      required: true
    }
  }
];

export default questionsModels;
